import React, {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronRight} from "@fortawesome/free-solid-svg-icons";

function StaticAssetTypeMobileTreeItem({
    item,
    depth,
    selectedId,
    onSelect,
    colName,
}) {
    const [expanded, setExpanded] = useState(false);
    const children = item.children ?? [];
    const hasChildren = children.length > 0;
    const label = colName ? item[colName] : item.name;
    const isSelected = selectedId != null && selectedId === item.id;

    const handleToggle = (event) => {
        event.stopPropagation();
        if (!hasChildren) return;
        setExpanded((prev) => !prev);
    };

    const handleSelect = () => {
        onSelect(item);
    };

    return (
        <li className="static-asset-type-tree__item">
            <div
                className={`static-asset-type-tree__row${isSelected ? " is-selected" : ""}`}
                style={{"--tree-depth": depth}}
            >
                {hasChildren ? (
                    <button
                        type="button"
                        className="static-asset-type-tree__toggle"
                        onClick={handleToggle}
                        aria-expanded={expanded}
                        aria-label={expanded ? `${label} 접기` : `${label} 펼치기`}
                    >
                        <FontAwesomeIcon icon={expanded ? faChevronDown : faChevronRight}/>
                    </button>
                ) : (
                    <span className="static-asset-type-tree__spacer" aria-hidden="true"/>
                )}
                <button
                    type="button"
                    className="static-asset-type-tree__label"
                    onClick={handleSelect}
                >
                    {label}
                </button>
            </div>

            {hasChildren && expanded && (
                <ul className="static-asset-type-tree__children">
                    {children.map((child) => (
                        <StaticAssetTypeMobileTreeItem
                            key={child.id}
                            item={child}
                            depth={depth + 1}
                            selectedId={selectedId}
                            onSelect={onSelect}
                            colName={colName}
                        />
                    ))}
                </ul>
            )}
        </li>
    );
}

function StaticAssetTypeMobileTree({data, selectedId, onSelect, colName}) {
    const items = Array.isArray(data) ? data : [];

    if (items.length === 0) {
        return (
            <div className="static-asset-type-tree__empty">
                목록이 없습니다.
            </div>
        );
    }

    return (
        <ul className="static-asset-type-tree">
            {items.map((item) => (
                <StaticAssetTypeMobileTreeItem
                    key={item.id}
                    item={item}
                    depth={0}
                    selectedId={selectedId}
                    onSelect={onSelect}
                    colName={colName}
                />
            ))}
        </ul>
    );
}

export default StaticAssetTypeMobileTree;
